import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {
  DictService, POST_TAG_TYPE_DEPARTMENT_TYPE, POST_TAG_TYPE_INSURANCE_COMPANY, POST_TAG_TYPE_POST_TYPE
} from "../../../../shared/services/dict.service";
import {HttpErrorResponse} from "@angular/common/http";
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {FormHelperService} from "../../../../shared/services/form-helper.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../../shared/services/auth.service";
import {delay, filter, finalize, first, take, takeUntil, tap} from "rxjs/operators";
import {from, of, ReplaySubject} from "rxjs";
import {TagService} from "../../../../shared/services/tag.service";
import {Tag} from "../../../../shared/interface/tag";
import {src} from "../../../../../environments/environment";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {TagUsers} from "../../../../shared/interface/tag-users";
import {UserService} from "../../../../shared/services/user.service";
import {UsersDialogComponent} from "../../../../shared/components/users-dialog/users-dialog.component";
import {User} from "../../../../shared/interface/user";
import {validPhoneNumber} from "../../../../shared/validator/phone-validator";
import {validEmailAddress} from "../../../../shared/validator/email-validator";
import {TagGraphics} from "../../../../shared/interface/tag-graphics";
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-tags-add',
  templateUrl: './tags-add.component.html',
  styleUrls: ['./tags-add.component.scss']
})
export class TagsAddComponent implements OnInit, OnDestroy, AfterViewInit {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  readonly POST_TAG_TYPE_POST_TYPE = POST_TAG_TYPE_POST_TYPE;

  @Input() tag?: Tag;
  @Input() mod = false;
  @Output() closeModification = new EventEmitter<any>();
  @ViewChild('imageSelect') imageSelect: ElementRef;

  tagForm: FormGroup;
  typeControl: FormControl;
  nameControl: FormControl;
  activeControl: FormControl;
  imageSelectControl: FormControl;
  headerControl: FormControl;
  userFormArray: FormGroup[] = [];
  graphicsFormArray: FormGroup[] = [];
  tagsFormValid = false;
  imgCnt = 0;
  departmentType = false;
  insuranceType = false;
  postType = false;
  maxSize = 1050000;

  readonly src = src;
  errors: any = {};
  items: Tag[] = [];
  userPermissions: ReplaySubject<UserPermissions>;
  processingRequest = false;
  init = false;

  imageFdorm: FormGroup;
  base64Image: string | ArrayBuffer | null = null;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private formHelper: FormHelperService,
    private snack: MatSnackBar,
    private dictService: DictService,
    private dialog: MatDialog,
    private tagService: TagService,
    private auth: AuthService,
    private userService: UserService,

  ) {
    this.userPermissions = auth.getUserPermissions();
    this.tagForm = fb.group({
      id: fb.control(''),
      active: this.activeControl = this.fb.control(''),
      name: this.nameControl = this.fb.control('', [Validators.required]),
      type: this.typeControl = this.fb.control('', [Validators.required]),
      header: this.headerControl = this.fb.control(''),
      users: fb.array(this.userFormArray),
      graphics: fb.array(this.graphicsFormArray),

    });
  }

  ngOnInit(): void {
    this.tagForm.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => this.tagsFormValid = this.tagForm.valid);

    this.typeControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((dictId: number) => {
        this.departmentType = false;
        this.dictService.getKey(dictId)
          .subscribe((dictKey: string) => {
            if (dictKey === POST_TAG_TYPE_DEPARTMENT_TYPE){
              this.departmentType = true;
              this.insuranceType = false;
              this.postType = false;
            } else if ( dictKey === POST_TAG_TYPE_INSURANCE_COMPANY){
              this.departmentType = false;
              this.insuranceType = true;
              this.postType = false;
            }else if ( dictKey === POST_TAG_TYPE_POST_TYPE) {
              this.departmentType = false;
              this.insuranceType = false;
              this.postType = true;
            } else{
              this.departmentType = false;
              this.insuranceType = false;
              this.postType = false;
            }
            if (this.init) {
              this.init = false ;
            } else {
              if (this.postType) {
                this.graphicsFormArray = [];
                this.addGraphics('postType', 0, null, null, null);

              } else {
                this.graphicsFormArray = [];
                this.items.forEach((item: Tag) => {
                  this.addGraphics(item.name, item.id, null, null, null);
                });
              }
            }
          });
      });



  }

  ngAfterViewInit(): void {
    this.tagService.getTagDictSubject()
      .pipe(first())
      .subscribe((items: Tag[]) => {
        let val = [];
        items.forEach((item: Tag) => {
          if (item.type.key === POST_TAG_TYPE_POST_TYPE) {
            val.push(item);
          }
        })
        this.items = val;
        this.items.sort((a, b) => {
          return (a.name ).localeCompare(b.name );
        });
      });

    if (this.tag) {
          this.initialize(this.tag);
    } else {
      this.initialized.next(true);
      this.items.forEach((item: Tag) => {
        this.addGraphics(item.name, item.id, null, null, null);
      });
    }
  }



  initialize(tag: Tag): void {
    of(tag)
      .pipe(
        delay(0),
        tap(() => {
          this.init = true;
          this.tagForm.reset({
            id: tag.id,
            name: tag.name,
            type: tag.type.id,
            active: tag.active,
            header: tag.header,
          });

          tag.users
            .forEach((users: TagUsers) =>
              this.addUsers(false, users.usersUuid, users.usersName,
              users.usersPosition, users.usersPhone, users.usersEmail));

          tag.graphics
            .forEach((graphics: TagGraphics) =>
              this.addGraphics( graphics.graphicsType, graphics.graphicsTypeId, graphics.graphicsUuid, graphics.graphicsFilename,
                graphics.graphicsLocation));

            this.editGraphics();

        }),
        delay(0),
        tap(() => this.initialized.next(true))
      ).subscribe();
  }

  addUsers(dialog = false, usersUuid?: string, usersName?: string, usersPosition?: string, usersPhone?: string, usersEmail?: string): void {
    this.processingRequest = true;

    if (dialog) {
      const dialogRef = this.dialog.open(UsersDialogComponent, {
        width: '500px',
        data: {text: 'Wybierz użytkownika.'},
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.checkAndAddUser(result);
        }
      }, (error: HttpErrorResponse) => {
        this.snack.open('Błąd podczas zamykania okna dialogowego', error.status.toString(), {
          duration: 2000
        });
      });

    } else if (usersUuid) {
      this.checkAndAddUser(usersUuid, usersName, usersPosition, usersPhone, usersEmail);
    } else {
      this.snack.open('Nie można dodać użytkownika bez UUID', '', {
        duration: 2000
      });
    }

    this.updateUsersFormArray();
  }

  private checkAndAddUser(usersUuid: string, usersName?: string, usersPosition?: string, usersPhone?: string, usersEmail?: string): void {
    // Sprawdzenie, czy użytkownik już istnieje w formularzu
    const exists = this.userFormArray.some((user: FormGroup) => user.get('usersUuid')?.value === usersUuid);

    if (exists) {
      this.snack.open('Wybrany użytkownik już jest dodany', '', {
        duration: 2000
      });
      return;
    }

    // Jeśli dane użytkownika są już przekazane
    if (usersName) {
      this.addUserToForm(usersUuid, usersName, usersPosition, usersPhone, usersEmail);
    } else {
      // Pobieranie danych użytkownika z API
      this.userService.get(usersUuid).subscribe((user: User) => {
        this.addUserToForm(user.uuid, `${user.firstName} ${user.lastName}`, user.position, user.phone, user.email);
      }, (error: HttpErrorResponse) => {
        this.snack.open('Nie udało się pobrać danych użytkownika', error.status.toString(), {
          duration: 2000
        });
      });
    }
  }

  private addUserToForm(usersUuid: string, usersName: string, usersPosition?: string, usersPhone?: string, usersEmail?: string): void {
    this.userFormArray.push(new FormGroup({
      usersUuid: new FormControl(usersUuid || '', [Validators.required]),
      usersName: new FormControl(usersName || '', [Validators.required]),
      usersPosition: new FormControl(usersPosition || ''),
      usersPhone: new FormControl(usersPhone || '', [Validators.required, validPhoneNumber()]),
      usersEmail: new FormControl(usersEmail || '', [Validators.required, validEmailAddress()]),
    }));
  }

  updateUsersFormArray(): void {
    this.tagForm.setControl('users', new FormArray(this.userFormArray));
    this.processingRequest = false;
  }
  removeUsers(index: number): void {
    this.userFormArray.splice(index, 1);
    this.updateUsersFormArray();
  }


  addGraphics(graphicsType?: string, graphicsTypeId?: number,
              graphicsUuid?: string, graphicsFilename?: string,
              graphicsLocation?: string): void {

    this.graphicsFormArray.push(new FormGroup({
        graphicsUuid: new FormControl(graphicsUuid || uuidv4(), [Validators.required]),
        graphicsFilename: new FormControl(graphicsFilename || ''),
        graphicsContent:  new FormControl( ''),
        graphicsLocation: new FormControl(graphicsLocation || ''),
        graphicsType: new FormControl(graphicsType , [Validators.required]),
        graphicsTypeId: new FormControl(graphicsTypeId , [Validators.required]),

      }));


    this.updateGraphicsFormArray();
  }
  updateGraphicsFormArray(): void {
    this.tagForm.setControl('graphics', new FormArray(this.graphicsFormArray));
  }
  removeGraphics(index: number): void {
    this.graphicsFormArray.splice(index, 1);
    this.updateGraphicsFormArray();
  }
  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  cancel(): void {
    if (!this.tag) {
      this.router.navigate(['/asf360/tagi']);
    } else {
      this.closeModification.emit();
    }
  }

  sendForm(): void {
    this.updateUsersFormArray();
    this.formHelper.removeBackendErrorState(this.tagForm, this.errors);
    this.errors = {};
    this.tagService.send(this.tagForm.value)
      .subscribe(() => {
        this.snack.open(this.tag ? 'Pomyślnie zaktualizowano TAG' : 'Pomyślnie dodano TAG', '', {
          duration: 2000,
        });
        this.closeModification.emit();
        if (!this.tag) {
          this.router.navigate(['/asf360/tagi']);
        }
      }, (error: HttpErrorResponse) => {

        if (error.status === 400) {
          this.errors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.tagForm, this.errors);
          this.snack.open(error.error.error.text, '400', {duration: 2000});
        } else {
          this.snack.open('Podczas dodawania postu wystąpił błąd', error.status.toString(), {
            duration: 2000,
          });
        }
      });
  }

  onFileChange(event: any, index: number) {
    this.graphicsFormArray[index].get('graphicsContent').setValue(event['base64']);
    this.graphicsFormArray[index].get('graphicsFilename').setValue( event['filename']);
  }


  editGraphics(): void {
    if (this.tag.type.key === POST_TAG_TYPE_POST_TYPE) {
      let  exists = false ;
      this.graphicsFormArray.forEach((graphics: FormGroup  )=> {
        if (Number(graphics.get('graphicsTypeId').value) ===  0){
          exists = true;
        }
      });
      if (!exists) {
        this.addGraphics('postType', 0, null, null, null);
      }
    } else {
      this.items.forEach((item: Tag) => {
        let exists = false;
        this.graphicsFormArray.forEach((graphics: FormGroup) => {
          if (Number(graphics.get('graphicsTypeId').value) === item.id) {
            exists = true;
          }
        });
        if (!exists) {
          this.addGraphics(item.name, item.id, null, null, null);
        }
      });
    }
  }
}
